module.exports = __webpack_public_path__ + "static/media/dill.d1de6220.png";